// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"609d6b2f","453":"999a3c2e","987":"93f3b5ab"}[chunkId] + ".chunk.js";
};